import { render, staticRenderFns } from "./Requests.vue?vue&type=template&id=dab6204e&"
import script from "./Requests.vue?vue&type=script&lang=js&"
export * from "./Requests.vue?vue&type=script&lang=js&"
import style0 from "./Requests.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports